<script>
import { mediaComputed, mediaMethods, modalMethods } from '@state/helpers';

export default {
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mediaComputed,
  },
  mounted() {},
  methods: {
    ...mediaMethods,
    ...modalMethods,
  },
};
</script>

<template>
  <div class="global-uploader" transition>
    <div class="uploads">
      <div
        class="upload-item"
        v-if="signedPostData && signedPostData.length === 0"
      >
        <p class="type">No items to display</p>
      </div>
      <div
        class="upload-item"
        v-for="upload in signedPostData"
        :key="upload.type + '-' + upload.requestType"
      >
        <p class="type"
          >{{ upload.requestType }} - {{ upload.type }}:
          <span>{{ upload.uploadProgress }}% Complete</span></p
        >
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';
.global-uploader {
  background-color: white;
  border: 2px solid black;
  border-radius: 2rem;
  height: auto;
  padding: 5px;
  position: absolute;
  right: 0;
  top: 76px;
  transform: translate(100%, 0%);
  transition: transform 0.2s ease-in-out;
  width: 450px;
  z-index: 900;
  &.isVisible {
    transform: translate(-25%, 0%);
  }

  .title {
    color: white;
    font-size: 20px;
  }
  .uploads {
    .upload-item {
      background-color: white;
      border-radius: 2rem;
      color: black;
      .type {
        font-weight: 800;
        margin-bottom: unset;
        text-transform: capitalize;
        span {
          font-weight: 400;
        }
      }
    }
  }
}
</style>
